<template>
  <div class="card detail-container">
    <!-- Header Bar -->
    <div class="header-bar">
      <button class="btn secondary" @click="$router.back()">⬅ Kembali</button>
      <h3 class="detail-title">Detail Data Nasabah</h3>
    </div>

    <!-- Container Content -->
    <div v-if="loading" class="loading-box">
      <div class="spinner"></div>
      <span>Memuat data nasabah...</span>
    </div>

    <div v-else class="detail-grid">
      <!-- Info Nasabah & Pengajuan (Kolom Kiri) -->
      <div class="detail-section">
        <h4 class="section-title">
          <span class="icon">👤</span> Informasi Nasabah
        </h4>
        <div class="detail-list">
          <div class="detail-item">
            <span class="detail-label">Nomor Pendaftaran (NOPEN)</span>
            <span class="detail-value highlight">{{ data.nopen || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">KTP Nasabah</span>
            <span class="detail-value">{{ data.ktp_nasabah || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Nama Nasabah</span>
            <span class="detail-value text-bold">{{ data.nama_nasabah || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Instansi / Kerja</span>
            <span class="detail-value">{{ data.kerja_nasabah || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Tipe Debitur</span>
            <span class="detail-value">{{ data.debitur_nama || '-' }}</span>
          </div>
        </div>

        <h4 class="section-title margin-top">
          <span class="icon">📝</span> Pengajuan
        </h4>
        <div class="detail-list">
          <div class="detail-item">
            <span class="detail-label">Tanggal Pengajuan</span>
            <span class="detail-value">{{ formatDate(data.tgl_pengajuan) }}</span>
          </div>
          <div v-if="data.tgl_pencairan" class="detail-item">
            <span class="detail-label">Tanggal Pencairan</span>
            <span class="detail-value">{{ formatDate(data.tgl_pencairan) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Jenis Pengajuan</span>
            <span class="detail-value">{{ data.pengajuan_nama || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Jenis PK</span>
            <span class="detail-value">{{ data.jenis_pk || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Tipe</span>
            <span class="detail-value badge" :class="data.tipe == '1' ? 'badge-konven' : 'badge-syariah'">
              {{ data.tipe == '1' ? 'Konvensional' : 'Syariah' }}
            </span>
          </div>
          <div v-if="data.takeoffer" class="detail-item">
            <span class="detail-label">Status Take Over</span>
            <span class="badge badge-warning">Take Over</span>
          </div>
        </div>
      </div>

      <!-- Info Keuangan & Marketing (Kolom Kanan) -->
      <div class="detail-section">
        <h4 class="section-title">
          <span class="icon">💰</span> Detail Finansial
        </h4>
        <div class="detail-list">
          <div class="detail-item">
            <span class="detail-label">Plafond</span>
            <span class="detail-value text-navy text-bold">Rp {{ formatRupiah(data.plafond) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Bakidebet</span>
            <span class="detail-value">Rp {{ formatRupiah(data.bakidebet) }}</span>
          </div>
          <div class="detail-item highlight-box">
            <span class="detail-label">Realisasi Bersih (Reber)</span>
            <span class="detail-value text-orange text-bold">Rp {{ formatRupiah(data.reber) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Jangka Waktu</span>
            <span class="detail-value">{{ data.jangka_waktu ? data.jangka_waktu + ' Bulan' : '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Cabang</span>
            <span class="detail-value">{{ data.cabang_nama || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Jenis Produk</span>
            <span class="detail-value">{{ data.nama_produk || '-' }}</span>
          </div>
        </div>

        <h4 class="section-title margin-top">
          <span class="icon">🤝</span> Petugas
        </h4>
        <div class="detail-list">
          <div class="detail-item">
            <span class="detail-label">Nama HS</span>
            <span class="detail-value">{{ data.nama_hs || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Nama TL</span>
            <span class="detail-value">{{ data.nama_tl || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Nama MR</span>
            <span class="detail-value">{{ data.nama_mr || '-' }}</span>
          </div>
          <div v-if="data.nama_fee_mr" class="detail-item">
            <span class="detail-label">Nama Fee Marketing</span>
            <span class="detail-value">{{ data.nama_fee_mr || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NasabahDetail",
  data() {
    return {
      data: {},
      loading: true,
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      const stateData = history.state;
      const id = stateData?.id_transaksi || stateData?.id;

      if (!id) {
        this.loading = false;
        return;
      }

      fetch(`${this.$apiURL}/v1/get_data_nasabah_by_id`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({
          id: id
        }),
      })
      .then(response => response.json())
      .then((result) => {
        this.data = result || {};
        this.loading = false;
      })
      .catch((err) => {
        console.error("Detail Fetch Error:", err);
        this.loading = false;
      });
    },
    formatRupiah(val) {
      if (!val && val !== 0) return '0';
      return Number(val).toLocaleString('id-ID');
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      try {
        const parts = dateStr.split('-');
        if (parts.length === 3) {
          return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        return dateStr;
      } catch (e) {
        return dateStr;
      }
    }
  },
};
</script>

<style scoped>
.header-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf2f7;
}

.detail-title {
  margin: 0;
  font-size: 1.3rem;
  color: #0b1953;
  font-weight: 700;
}

/* Grid Layout */
.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

@media (max-width: 768px) {
  .detail-grid {
    grid-template-columns: 1fr;
  }
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.05rem;
  color: #0b1953;
  margin-top: 0;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 2px solid #f47b20;
}

.margin-top {
  margin-top: 24px;
}

.detail-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.highlight-box {
  background-color: #fef8f4;
  border-color: #f47b20;
}

.detail-label {
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 500;
}

.detail-value {
  font-size: 0.9rem;
  color: #1e293b;
  font-weight: 600;
}

.text-navy {
  color: #0b1953;
}

.text-orange {
  color: #f47b20;
}

.text-bold {
  font-weight: 700;
}

/* Badges */
.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge-konven {
  background-color: #e0f2fe;
  color: #0369a1;
}

.badge-syariah {
  background-color: #dcfce7;
  color: #15803d;
}

.badge-warning {
  background-color: #fffbeb;
  color: #b45309;
  border: 1px solid #fcd34d;
}

/* Loading Box */
.loading-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 0;
  color: #0b1953;
  font-weight: 600;
}

.spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #e2e8f0;
  border-top-color: #f47b20;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>